import convert from 'convert-units';

import ElementBase from './ElementBase';
import generateId from '../generateId';
import {
  distanceOrDurationUnitsEnum,
  inputTypesEnum,
  plannerComponentTypesEnum,
  zoneEnum,
} from './enums';
import store from '../../store/store';

// In many respects it would be simpler to have TrainingPlannerDistanceElement
// and TrainingPlannerDurationElement but I couldn't figure out how to make that work
// with vuelidate and how WorkoutPlanner.vue and WorkoutComponent.vue work
// together. You'd somehow have to change an object type on the fly. Having just one
// ActivityElement simplified that part of things while forcing us to use
// a bunch of switch statements here. If you have a better way to do it please change it.
export default class ActivityElement extends ElementBase {
  // @param activityElement is a plain object with the desired properties set
  constructor(activityElement = null) {
    const id = (activityElement && activityElement.id) ? activityElement.id : generateId();
    super(plannerComponentTypesEnum.activity, id);
    this._inputType = inputTypesEnum.distance;
    this.value = null;
    this.units = distanceOrDurationUnitsEnum.miles;
    this.zone = zoneEnum.zone1;
    this.componentTypeDescription = null;

    const ae = activityElement;
    if (activityElement && activityElement.Inputtype) {
      ae._inputType = activityElement.Inputtype;
    }
    Object.assign(this, ae);
  }

  get inputType() {
    return this._inputType;
  }

  set inputType(inputType) {
    if (this._inputType !== inputType) {
      this._inputType = inputType;
      switch (inputType) {
        case inputTypesEnum.distance:
          this.units = distanceOrDurationUnitsEnum.miles;
          break;
        case inputTypesEnum.duration:
          this.units = distanceOrDurationUnitsEnum.minutes;
          break;
        default:
          console.error(`Unknown input type: ${this.inputType}`);
      }
    }
  }

  get estimatedDistance() {
    let distance = 0;
    switch (this.units) {
      case distanceOrDurationUnitsEnum.meters:
      case distanceOrDurationUnitsEnum.kilometers:
      case distanceOrDurationUnitsEnum.miles:
      case distanceOrDurationUnitsEnum.yards:
        distance = this._getEstimatedDistanceForDistanceActivity();
        break;
      case distanceOrDurationUnitsEnum.hours:
      case distanceOrDurationUnitsEnum.minutes:
      case distanceOrDurationUnitsEnum.seconds:
        distance = this._getEstimatedDistanceForDurationActivity();
        break;
      default:
        console.error(`Unknown input type: ${this.inputType}`);
    }
    return distance;
  }

  get estimatedDuration() {
    let duration = 0;
    switch (this.units) {
      case distanceOrDurationUnitsEnum.meters:
      case distanceOrDurationUnitsEnum.kilometers:
      case distanceOrDurationUnitsEnum.miles:
      case distanceOrDurationUnitsEnum.yards:
        duration = this._getEstimatedDurationForDistanceActivity();
        break;
      case distanceOrDurationUnitsEnum.hours:
      case distanceOrDurationUnitsEnum.minutes:
      case distanceOrDurationUnitsEnum.seconds:
        duration = this._getEstimatedDurationForDurationActivity();
        break;
      default:
        console.error(`Unknown input type: ${this.inputType}`);
    }
    return duration;
  }

  // Returns distance in meters
  _getEstimatedDistanceForDistanceActivity() {
    let distance = 0;

    this._assertIsValidDistanceActivity();

    if (this.value) {
      switch (this.units) {
        case distanceOrDurationUnitsEnum.meters:
          distance = this.value;
          break;
        case distanceOrDurationUnitsEnum.kilometers:
          distance = convert(this.value).from('km').to('m');
          break;
        case distanceOrDurationUnitsEnum.miles:
          distance = convert(this.value).from('mi').to('m');
          break;
        case distanceOrDurationUnitsEnum.yards:
          distance += convert(this.value * 3).from('ft-us').to('m');
          break;
        default:
          console.error(`Unknown distance unit: ${this.units}`);
      }
    }

    return distance;
  }

  // Returns distance in miles
  _getEstimatedDistanceForDurationActivity() {
    return this._getEstimatedDurationForDurationActivity() * store.getters.velocity(this.zone);
  }

  // Return duration in seconds
  _getEstimatedDurationForDistanceActivity() {
    return this._getEstimatedDistanceForDistanceActivity() / store.getters.velocity(this.zone);
  }

  // Return duration in seconds
  _getEstimatedDurationForDurationActivity() {
    let duration = 0;

    this._assertIsValidDurationActivity();

    if (this.value) {
      switch (this.units) {
        case distanceOrDurationUnitsEnum.seconds:
          duration = this.value;
          break;
        case distanceOrDurationUnitsEnum.minutes:
          duration = convert(this.value).from('min').to('s');
          break;
        case distanceOrDurationUnitsEnum.hours:
          duration = convert(this.value).from('h').to('s');
          break;
        default:
          console.error(`Unknown duration unit: ${this.units}`);
      }
    }

    return duration;
  }

  _assertIsValidDistanceActivity() {
    // if (!this.inputType) {
    //   console.error('Input type must be defined');
    // }
    //
    // if (this.inputType !== inputTypesEnum.distance) {
    //   console.error(`Expected a distance input type (${inputTypesEnum.distance})`);
    // }
    //
    // if (!this.units) {
    //   console.error('Input type must be defined');
    // }

    return true;
  }

  _assertIsValidDurationActivity() {
    if (!this.inputType) {
      console.error('Input type must be defined');
    }

    if (this.inputType !== inputTypesEnum.duration) {
      console.error(`Expected a duration input type (${inputTypesEnum.duration})`);
    }

    if (!this.units) {
      console.error('Input type must be defined');
    }

    return true;
  }
}
